import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const editModalCategorySlice = createSlice({
  name: "editModalCategory",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = true;
    },
    closeModal: (state, action) => {
      const itemId = action.payload;
      state[itemId] = false;
    },
  },
});

export const { openModal, closeModal } = editModalCategorySlice.actions;

export default editModalCategorySlice.reducer;